import { useQuery } from '@tanstack/react-query';
import assistantService from '@services/assistant';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const ASSISTANT_AVAILABLE_QUERY_KEY = 'assistantAvailable';

/** No permission gate on the backend query, mirroring `useAiPlanningAvailable` — `staleTime` kept
 * long since this rarely flips within a session. */
export const useAssistantAvailable = () => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [ASSISTANT_AVAILABLE_QUERY_KEY, organizationId],
    queryFn: () => assistantService.getAssistantAvailable(),
    enabled: !!organizationId,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
};

export default useAssistantAvailable;
